<template>
  <div v-show="!isEmpty(powerData.snapshotDoc)">
    <el-row type="flex" class="title-bar" justify="space-between">
      <div>
        <span class="tit content-title">전력</span>
        <span class="condition-text">({{ dateLabel }})</span>
      </div>
      <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-table-wrapper :data="powerData.snapshotDoc" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" :pagination="true" :column-default="columnDefault">
    </el-table-wrapper>
  </div>
</template>

<script>
import { isNil, isEmpty } from 'lodash';
import { isTrue } from '@/utils/boolean';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { getDateLabel } from '../../../../utils/fault-analysis';
import { etcInfoDefine } from '../../../../constants/fault-analysis';

export default {
  name: 'WInterfaceTable',
  props: {
    /**
     * 기타 분석 정보 조회 시 필요한 정보 객체 (동시성 문제 고려하여 하나의 객체로 전달)
     * 1) obj: 분석 대상 장비 정보
     * 2) eventHistData: 분석 이벤트 이력 정보
     * 3) etcInfo: 기타 분석 정보
     * @type {Object}
     */
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columnDefault,
      powerData: {},
      showSearchTool: false,
      columns: [
        {
          prop: 'netinterfaceIfindex',
          label: '인덱스',
          searchable: true,
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objName',
          label: '인터페이스명',
          searchable: true,
          scopedSlot: 'interface-name',
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netinterfaceAlias',
          label: '별칭',
          searchable: true,
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'POE_PORT/POE_PORT',
          label: '파워 상태',
          sortable: true,
          formatter: this.getPoEStatusValue,
        },
        {
          prop: 'POE_PORT/PORT_POWER_CONSUMED',
          label: 'PD 소비 전력',
          sortable: true,
          formatter: this.getPoePowerValue,
        },
        {
          prop: 'POE_PORT/PORT_POWER_ALLOCATED',
          label: 'PSE 예약 전력',
          sortable: true,
          formatter: this.getPoePowerValue,
        },
      ],
    };
  },
  computed: {
    dateLabel() {
      return isNil(this.powerData.timestamp) ? EMPTY_TEXT : getDateLabel(this.powerData.timestamp);
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(to) {
        this.reset();
        if (!isNil(to)) {
          this.setData();
        }
      },
    },
  },
  methods: {
    isTrue,
    isEmpty,
    /**
     * [인터페이스] etcInfo에 전달된 인터페이스 데이터 바인딩
     * @author jeee12
     */
    setData() {
      if (!isEmpty(this.data.etcInfo) && !isEmpty(this.data.etcInfo[etcInfoDefine.POE_PORT_POWER])) {
        this.powerData = this.data.etcInfo[etcInfoDefine.POE_PORT_POWER];
      }
    },
    /**
     * 화면을 초기화한다.
     * @author Ju
     */
    reset() {
      this.powerData = {};
    },
    /**
     * 테이블 데이터 공백 처리
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * PoE 상태 formatter
     * @author Hunui
     */
    getPoEStatusValue(row, column, value) {
      if (isNil(value) || value === '') {
        return EMPTY_TEXT;
      }
      return isTrue(value) ? 'UP' : 'DOWN';
    },
    /**
     * PoE 전력값 formatter
     * @author Hunui
     */
    getPoePowerValue(row, column, value) {
      // TODO: 현재 현재값은 DB에서 조회하여 rsc_unit을 가져오나 스냅샷은 구현이 되어있지 않아 하드코딩
      //       추후 스냅샷도 수정하여 동적으로 바뀌도록 수정필요
      return isEmpty(value) ? convertValuByUnit(value, 'w', true, false, false, true) : getValueAfterCheckEmpty(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/popup/FaultAnalysisPopup/components/FaultAnalysisInfoView/EtcInfo/NetdeviceEtcInfoView/PortPowerTable.vue